// extracted by mini-css-extract-plugin
module.exports = {"root":"Trend_root__1gnqh","icon":"Trend_icon__1WEiA","text":"Trend_text__1ni3i","student":"Trend_student__2us3n"};